// https://github.com/react-component/slider

import "../styling/App.css";
import React, { Component } from "react";
import Slider, { SliderTooltip } from "rc-slider";
import numbro from "numbro";

const Handle = Slider.Handle;

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <SliderTooltip
      prefixCls="rc-slider-tooltip"
      overlay={numbro(value)
        .format({ thousandSeparated: true })
        .replace(",", ".")}
      visible={true}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </SliderTooltip>
  );
};

class OurSlider extends Component {
  render() {
    return (
      <div>
        <div className="defaultSliderStyle">
          <div className="sliderLeft">
            <div className=".absoluteCenter">
              <p className="scriptedHeading">{this.props.scriptedHeading}</p>
              <div className="subheading">
                {this.props.subheading}
                <div className="textLeft">
                  <p className="explanatoryText">
                    {this.props.explanatoryText}
                  </p>
                </div>
              </div>
            </div>
            <Slider
              min={this.props.min}
              max={this.props.max}
              step={this.props.step}
              defaultValue={this.props.defaultValue}
              handle={handle}
              onChange={this.props.onValueChange}
              onAfterChange={this.props.onValueChange}
            />{" "}
            <p className="minStyle">
              {numbro(this.props.min)
                .format({ thousandSeparated: true })
                .replace("k", " Tsd.")
                .replace("m", " Mio.")
                .replace(",", ".") +
                " " +
                this.props.unit}
            </p>
            <p className="maxStyle">
              {numbro(this.props.max)
                .format({ thousandSeparated: true })
                .replace("k", " Tsd.")
                .replace("m", " Mio.")
                .replace(",", ".") +
                " " +
                this.props.unit}
            </p>
          </div>
          <div className="sliderRight"></div>
        </div>
      </div>
    );
  }
}

export default OurSlider;
